import TableHeader, { TableHeaderProps } from './TableHeader';

export type { TableHeaderProps };
export default TableHeader;
